import './service-points-alerts.service';
import './service-points-api.factory';
import './service-points-requests.service';
import './service-points.service';
import './service-points-dialogs-service.service';
